import {Disclosure} from "@headlessui/react";
import cx from "classnames";
import {ChevronUpIcon} from "@heroicons/react/16/solid";
import {InvoiceCallbackRow} from "../../../components";
import {useProfile} from "../../../hooks";
import {useParams} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import {InvoiceApi} from "../../../api";

export const InvoiceCallbacksBlock = () => {
    const profile = useProfile();
    const {id} = useParams();
    const isCallbacksVisible = profile?.permissions.includes('merchant.callback.read');

    const {data: invoiceCallbacks} = useQuery({
        queryKey: [InvoiceApi.KEY, 'getInvoiceCallbacks', id],
        queryFn: () => InvoiceApi.getInvoiceCallbacks(id!),
        enabled: Boolean(id)
    })

    if (!isCallbacksVisible) return null

    return (
        <Disclosure>
            {({open}) => (
                <div className={cx(
                    'p-7 w-3/5 bg-white rounded-3xl',
                )}>
                    <Disclosure.Button
                        as={'h2'}
                        className={
                            cx(
                                'flex justify-between text-sm uppercase font-semibold cursor-pointer text-green-500',
                                open && 'mb-5',
                            )}
                    >
                        <span>Callbacks ({invoiceCallbacks?.length})</span>
                        <ChevronUpIcon
                            className={cx(
                                open ? 'rotate-180 transform' : '',
                                'text-green-500',
                                'h-5 w-5',
                            )}
                        />
                    </Disclosure.Button>
                    <Disclosure.Panel className="grid gap-4">
                        <table
                            className="min-w-full text-sm font-light text-surface w-5/5">
                            <thead className="border-b border-neutral-200 font-medium">
                            <tr>
                                <th scope="col" className="pb-5 uppercase text-start">ID</th>
                                <th scope="col" className="pb-5 uppercase text-start">Status</th>
                                <th scope="col" className="pb-5 uppercase text-start">For invoice status</th>
                                <th scope="col" className="pb-5 uppercase text-start">Create date</th>
                                <th scope="col" className="pb-5 uppercase text-start">Execution date</th>
                            </tr>
                            </thead>
                            <tbody>
                            {invoiceCallbacks?.map((invoiceCallback) => (
                                <InvoiceCallbackRow key={invoiceCallback.id} callback={invoiceCallback}/>
                            ))}
                            </tbody>
                        </table>
                    </Disclosure.Panel>
                </div>
            )}
        </Disclosure>
    )
}